<template>
    <div class="mainclass">
        <vch-product-filters v-if="!matchMedia && filters.length" :filters="filters" :clear-btn-title="clearBtnTitle"></vch-product-filters>
    </div>
</template>
<script>
export default {
    name: 'vch-product-filters-desktop',
    props:{
        filters: {
            type: String,
            required: true,
        },
        clearBtnTitle: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            matchMedia: null,
        };
    },
    mounted() {
        this.matchMedia = window.matchMedia('(max-width: 1024px)').matches;
    }
}
</script>

<style>

</style>